import * as React from 'react'
import { compose, pure } from 'recompose'

import TextLabel, { SizeType } from '../../atoms/TextLabel/TextLabel'

import * as styles from './PrepareParticipantStatus.css'

interface PrepareParticipantStatusProps {
  count: number
}

const PrepareParticipantStatus: React.FunctionComponent<PrepareParticipantStatusProps> = ({ count }) => (
  <div className={styles.circle}>
    <div className={styles.count}>
      <span className={styles.countText}>{count}</span>
      <span className={styles.text}>人参加中</span>
    </div>
    <div className={styles.message}>
      <TextLabel size={SizeType.MEDIUM}>開始までしばらくお待ち下さい</TextLabel>
    </div>
  </div>
)

export default compose<PrepareParticipantStatusProps, PrepareParticipantStatusProps>(pure)(PrepareParticipantStatus)
